import { selectEmail } from 'core/userContext';
import { DeleteViewModal } from 'modules/messagingInsights/components/SavedViews/modals/DeleteViewModal';
import { FC, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import styled from 'styled-components';
import { BulkActionsBar } from 'ui/bulkActionsBar';
import { Delete16 } from 'ui/icons';
import { Tab, TabGroup } from 'ui/tabs';
import { FullWidth } from 'ui/utility/fullWidth';
import { fonts, spacing } from 'ui/theme';
import { CREATOR_FILTER_TABS } from '../constants';
import { useQueryContext, useSelectionContext } from '../context';
import { bulkDeleteViewsRequest } from '../redux/actions';
import { SavedViewsSearchBar } from './SavedViewsSearchBar';

const Wrapper = styled.div`
  display: flex;
  justify-content: space-between;
  font-family: ${fonts.sansSerif};
  margin-bottom: ${spacing.base};
  margin-top: ${spacing.plusHalf};
`;

export const SavedViewsTableFilters: FC = () => {
  const dispatch = useDispatch();
  const userEmail = useSelector(selectEmail) || '';
  const { creatorFilter, setCreatorFilter, toggleRefetchViews, setCurrentPage } = useQueryContext();
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const { selected, deleteDataByViewId, deselectAll } = useSelectionContext();
  const viewsToBeDeleted = selected.map((id) => deleteDataByViewId[id]);

  const callback = () => {
    setCurrentPage(1);
    toggleRefetchViews();
    deselectAll();
  };
  const deleteViews = () => {
    dispatch(bulkDeleteViewsRequest(viewsToBeDeleted, userEmail, callback));
  };

  const bulkActions = [
    {
      icon: <Delete16 />,
      label: 'Delete',
      onClick: () => {
        setShowDeleteModal(true);
      },
      sortIndex: 0,
    },
  ];

  return (
    <>
      {selected?.length ? (
        <FullWidth>
          <BulkActionsBar actions={bulkActions} numSelected={selected.length} />
          {showDeleteModal && (
            <DeleteViewModal
              viewsToBeDeleted={viewsToBeDeleted}
              deleteViews={deleteViews}
              onClose={() => setShowDeleteModal(false)}
            />
          )}
        </FullWidth>
      ) : (
        <Wrapper>
          <TabGroup selectedTab={creatorFilter} onTabChange={(id) => setCreatorFilter(id)}>
            {CREATOR_FILTER_TABS.map((tab) => (
              <Tab id={tab.id} key={tab.id}>
                {tab.label}
              </Tab>
            ))}
          </TabGroup>
          <SavedViewsSearchBar />
        </Wrapper>
      )}
    </>
  );
};
